module.exports = __webpack_public_path__ + "static/img/product_society_society_syzl.f9bf577.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_syzl.svg
// module id = ZuD3
// module chunks = 0